import React from 'react';
import { Card } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Button } from '../components/ui/button';
import AppSidebar from '../components/AppSidebar';
import SignalSourcesPanel from '../components/SignalSourcesPanel';
import { useWorkspace } from '../contexts/WorkspaceContext';
import { Rss, ExternalLink } from 'lucide-react';

const KNOWLEDGE_LINKS = [
  {
    label: 'Every subreddit has an RSS feed — append /.rss to the URL',
    href: 'https://www.reddit.com/wiki/rss/',
  },
  {
    label: 'HN topic feeds via hnrss.org',
    href: 'https://hnrss.org/',
  },
];

const SourcesPage = () => {
  const { currentWorkspaceId, currentWorkspace } = useWorkspace();

  return (
    <div className="min-h-screen bg-background flex" data-testid="sources-page">
      <AppSidebar />
      <main className="flex-1 min-w-0">
        <div className="container mx-auto max-w-4xl px-4 sm:px-8 py-8">
          <header className="mb-6">
            <div className="flex items-center gap-2 mb-2">
              <div className="rounded-md bg-primary/10 p-2">
                <Rss className="h-5 w-5 text-primary" />
              </div>
              <h1 className="text-2xl font-bold tracking-tight">Signal Sources</h1>
              <Badge variant="outline" className="text-[10px] border-primary/40 text-primary">Beta</Badge>
            </div>
            <p className="text-sm text-muted-foreground">
              Connect Reddit, Hacker News or any RSS feed. VibeSprint fetches new items nightly
              and drops them into <span className="font-medium text-foreground">{currentWorkspace?.name || 'your workspace'}</span>.
            </p>
          </header>

          {currentWorkspaceId && (
            <SignalSourcesPanel workspaceId={currentWorkspaceId} />
          )}

          <Card className="mt-8 p-5" data-testid="sources-help">
            <h3 className="text-sm font-semibold mb-3">Where to find good feeds</h3>
            <ul className="space-y-2">
              {KNOWLEDGE_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-sm text-primary hover:underline"
                  >
                    {link.label}
                    <ExternalLink className="h-3 w-3" />
                  </a>
                </li>
              ))}
            </ul>
          </Card>
        </div>
      </main>
    </div>
  );
};

export default SourcesPage;
